import { createSlice, isFulfilled, isPending, isRejected, } from "@reduxjs/toolkit";
import { globalSearchAsync } from "../globalSearch/globalSearchThunk";
export const loadingSlice = createSlice({
    name: "app/loading",
    initialState: {
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher((action) => isPending(action) && action.type !== globalSearchAsync.pending.type, (state) => {
            state.isLoading = true;
        });
        builder.addMatcher(isFulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addMatcher(isRejected, (state) => {
            state.isLoading = false;
        });
    },
});
export default loadingSlice.reducer;
